import { Controller } from "@hotwired/stimulus"
import { ExaminationService } from "../services/examination_service"

export default class extends Controller {
  static targets = ["status", "field"]
  static values = {
    field: String,
    examinationId: String,
    debounceMs: { type: Number, default: 1500 }
  }

  connect() {
    this.debounceTimer = null
    this.isInitialLoad = true
    this.originalValue = this.hasFieldTarget ? this.fieldTarget.value : ''
    this.showStatus("ready", "")
  }

  disconnect() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
    }
  }


  handleInput() {
    if (this.isInitialLoad) {
      this.isInitialLoad = false
      return
    }

    this.showStatus("editing", "編集中")

    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
    }

    this.debounceTimer = setTimeout(() => {
      this.save()
    }, this.debounceMsValue)
  }

  handleBlur() {
    const currentValue = this.hasFieldTarget ? this.fieldTarget.value : ''
    if (currentValue !== this.originalValue) {
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer)
      }
      this.save()
    }
  }

  async save() {
    const currentValue = this.hasFieldTarget ? this.fieldTarget.value : ''
    if (currentValue === this.originalValue) {
      return
    }

    this.showStatus("saving", "保存中...")

    const result = await ExaminationService.update(this.examinationIdValue, {
      [this.fieldValue]: currentValue
    })

    if (result.success) {
      this.originalValue = currentValue
      this.showStatus("saved", "✓ 保存済み")
      setTimeout(() => {
        this.showStatus("ready", "")
      }, 2000)
    } else {
      console.error('Auto-save error:', result.error)
      this.showStatus("error", "⚠ 保存失敗")
      setTimeout(() => {
        this.showStatus("ready", "")
      }, 5000)
    }
  }

  showStatus(state, message) {
    if (!this.hasStatusTarget) return

    const statusElement = this.statusTarget
    statusElement.textContent = message
    
    // 既存のクラスを削除
    statusElement.classList.remove(
      'text-gray-500', 'text-blue-500', 'text-green-600', 'text-red-600'
    )
    
    // 状態に応じたクラスを追加
    switch (state) {
      case 'ready':
        statusElement.classList.add('text-gray-500')
        break
      case 'editing':
        statusElement.classList.add('text-blue-500')
        break
      case 'saving':
        statusElement.classList.add('text-blue-500')
        break
      case 'saved':
        statusElement.classList.add('text-green-600')
        break
      case 'error':
        statusElement.classList.add('text-red-600')
        break
    }
  }


}